import { FunctionComponent, useMemo } from 'react'
import useStyles from './styles'
import { Icon } from '@conexasaude/iconography/icons'

import {
  getDateInFull,
  getDayPeriod,
  getTimeInHourAndMinute,
} from '@/utils/date'
import { capitalize } from '@/utils/fnUtils'
import { getCache } from '@/utils/cache'

import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { IMMEDIATE_ATTENDANCE } from '@/modules/Attendance/constants'
import { useCheckoutStore } from '@/stores'
import { RenderIf } from '@/components/RenderIf'
import { Tag, getTheme, Text } from '@conexasaude/conexa-hero'
import { useCheckoutContext } from '@/modules/Checkout/contexts/CheckoutContext'
import { ConfirmationReservationDetailsProps } from './types'

const ConfirmationReservationDetails: FunctionComponent<
  ConfirmationReservationDetailsProps
> = ({ date }) => {
  const styles = useStyles()
  const attendanceType = getCache('attendanceType')
  const { clinic } = useAuthContext()
  const { card, attendancePrice } = useCheckoutContext()
  const discount = useCheckoutStore(store => store.discount)
  const dateInFull = getDateInFull(date, {
    reversed: true,
  })
  const dayPeriod = getDayPeriod(date)
  const timeInHourAndMinute = getTimeInHourAndMinute(date)

  const finalPrice = useMemo(() => {
    return (attendancePrice.price - discount).toFixed(2).replace('.', ',')
  }, [attendancePrice.price, discount])
  const theme = getTheme()

  return (
    <div>
      <div>
        <div css={styles.wrapperTag}>
          <Tag variant="primary">Horário reservado</Tag>
        </div>
        <div css={styles.containerData}>
          <Icon name="calendar" size={21} color={theme.colors.neutral[300]} />
          <Text>{dateInFull}</Text>
        </div>
        <div css={styles.containerData}>
          <Icon name="clock" size={21} color={theme.colors.neutral[300]} />
          <Text>
            {timeInHourAndMinute} da {dayPeriod}
          </Text>
        </div>
        <RenderIf condition={!!card && clinic?.canPrivateAttendance}>
          <div css={styles.containerData}>
            <Icon
              name="credit-card"
              size={21}
              color={theme.colors.neutral[300]}
            />
            <Text>
              Cartão de {card?.type === 'CREDIT' ? 'Crédito' : 'Débito'}: ****{' '}
              {card?.finalCardNumbers} (
              {card ? capitalize(card?.flag?.toLowerCase()) : ''})
            </Text>
          </div>

          <div css={styles.containerData}>
            <Icon name="flag" size={21} color={theme.colors.neutral[300]} />
            <Text>Você pagará R$ {finalPrice}</Text>
          </div>
        </RenderIf>

        <RenderIf
          condition={
            clinic?.minimumHoursToCancel > 0 &&
            attendanceType !== IMMEDIATE_ATTENDANCE
          }
        >
          <Text>
            Você pode reagendar ou cancelar a consulta com até{' '}
            {clinic?.minimumHoursToCancel}h de antecedência.
          </Text>
        </RenderIf>
      </div>
    </div>
  )
}

export default ConfirmationReservationDetails
